import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { StorageService } from '@services';

/**
 * Bloquea el dominio /griky-skills si la compañía no tiene el módulo activo.
 * El permiso `permissions.grikySkillsModule` lo resuelve el CompanyGuardCheck /
 * CompanyResolver del route padre `:slug` y queda disponible en storage.
 */
@Injectable({ providedIn: 'root' })
export class GrikySkillsModuleGuard implements CanActivate {

    constructor(private router: Router, private storageService: StorageService) {}

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const company: any = this.storageService.get('company');

        if (company?.permissions?.grikySkillsModule) {
            return true;
        }

        // Sin módulo activo → redirige al home de la empresa
        const slug = this.getSlug(route) || company?.slug;
        return slug
            ? this.router.createUrlTree(['/learn', slug])
            : this.router.createUrlTree(['/login']);
    }

    /** El slug vive en el route padre `:slug`; se busca subiendo por la jerarquía. */
    private getSlug(route: ActivatedRouteSnapshot): string | null {
        let snap: ActivatedRouteSnapshot | null = route;
        while (snap) {
            const slug = snap.paramMap.get('slug');
            if (slug) { return slug; }
            snap = snap.parent;
        }
        return null;
    }
}
